export var AnimationStateEnum;

!function(AnimationStateEnum) {
    AnimationStateEnum.appear = "appear", AnimationStateEnum.disappear = "disappear", 
    AnimationStateEnum.enter = "enter", AnimationStateEnum.update = "update", AnimationStateEnum.state = "state", 
    AnimationStateEnum.exit = "exit", AnimationStateEnum.normal = "normal", AnimationStateEnum.none = "none";
}(AnimationStateEnum || (AnimationStateEnum = {}));
//# sourceMappingURL=interface.js.map